import styled from 'styled-components';

export const Button = styled.button`
  display: block;
  width: 100%;
  text-align: center;
  background: #f59947;
  color: #fff;
  border: none;
  border-radius: 1.5rem;
  padding: 1rem;
  margin-top: 1.5rem;
  text-transform: uppercase;
  font-weight: bold;

  &:hover {
    background: lighten(#f59947, 10%);
  }
`;
